// extracted by mini-css-extract-plugin
module.exports = {"heading":"hashtag_heading___oBER"};